export const mmMenuConstants = {
    menuApiRoute: "api/_menu",
    translationGroup: "_menu"
}